export default __webpack_public_path__ + "static/media/open.dd2bd3d6.png";